<div class="overlay" *ngIf="showSpinner">
  <div class="spinner-wrapper">
    <app-spinner>
      <span style="color: #27AE61; font-size: 3em;">
        <i class="fal fa-atom-alt fa-spin"></i>
      </span>
    </app-spinner>
  </div>
</div>
<div class="wraper">
  <div class="loaded-content">
    <div class="grid">
      <div class="col-6">
        <div class="col-12">
          <h3>Unload Rack</h3>
          <form #loadRackForm="ngForm">
            <div [hidden]="rack.SerialNumber">
              <label class="p-m-2">Rack Serial Number: </label>
              <input #searchTracking name="searchTracking" type="text" [(ngModel)]="trackingId" placeholder="scan rack">
              <button (click)="handleSearchButton()" style="margin-left:10px; padding:4px"><i class="fa fa-search fa-3x"></i></button>
            </div>
            <div [hidden]="!rack.SerialNumber">
              <p-button [hidden]="!rack.SerialNumber" class="p-button-success p-button-rounded" (click)="changeRack()" icon="pi pi-check" label="Change Rack"></p-button>
            </div>
          </form>
        </div>
        <div class="col-12" *ngIf="rack.Id">
          <div>
            <h4>Rack</h4>
          </div>
          <div>
            <label>Serial Number: </label>
            <b> {{rack.SerialNumber}}</b>
          </div>
          <div class="grid">
            <div class="p-col">
              <table>
                <tr>
                  <th></th>
                  <th *ngFor="let r of [].constructor(rack.RackType.Cols); let i = index">{{columnName[i]}}</th>
                </tr>
                <tr *ngFor="let c of [].constructor(rack.RackType.Rows); let x = index">
                  <td>{{x+1}}</td>
                  <td *ngFor="let r1 of [].constructor(rack.RackType.Cols); let y = index" style="width: 34px;">
                    <i class="fad fa-badge" [style.--fa-primary-color]="getColor(x, y)" style="--fa-primary-opacity: 1.0; --fa-secondary-opacity: 1.0;" title="{{getAccession(x, y)}}"></i>
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="col-6">
        <div *ngIf="rack.Id">
          <p-virtualscroller #vs [items]="rack.Contents" scrollHeight="600px" [itemSize]="65">
            <!--<ng-template pTemplate="header">-->
            <!--Contents of Rack: {{rack.SerialNumber}}-->
            <!--</ng-template>-->
            <ng-template #item let-cell let-options="options">
              <div class="clearfix">
                <h5 style="vertical-align: top !important; display: inline">{{cell.Row | rackLocation: cell.Col}}</h5>
                <span class="margin-left-10" style="vertical-align: top !important">{{cell.Accession}}</span>
                <span [hidden]="cell.StatusValue != 'danger'">
                  <p-button class="p-button-success m-3 p-m-2" (click)="saveLocation(cell.RequisitionId)" icon="pi pi-check" label="  Remove from Rack"></p-button>
                </span>
                <span [hidden]="cell.StatusValue != 'success'">
                  <p-button class="p-button-success m-3 p-m-2" (click)="validateOrder(cell.RequisitionId)" icon="pi pi-check" label="  Validate Resolution"></p-button>
                </span>
                <!--<span class="text-center" style="width: 100% !important">{{cell.FirstName}} {{cell.LastName}}</span>-->
                <span class="float-right margin-right-10">
                  <span class="float-right">{{cell.AddedDate | date:'MM/dd/yyyy HH:mm'}}</span><br />
                  <span class="float-right">
                    <span class="rounded-pill pl-2 pr-2" [ngClass]="{
                          'bg-red-400': cell.StatusText == 'Rejected',
                          'bg-yellow-400': cell.StatusText == 'Exceptions',
                          'bg-green-400': cell.StatusText != 'Rejected' && cell.StatusText != 'Exceptions'
                          }">{{cell.StatusText}}</span>
                  </span>
                </span>
              </div>
            </ng-template>
          </p-virtualscroller>
        </div>
      </div>
    </div>
  </div>
</div>

<p-toast>
</p-toast>

<p-blockUI [blocked]="loading">
  <i class="pi pi-lock" style="font-size: 3rem"></i>
</p-blockUI>

<p-dialog [(visible)]="showNameConfirmDialog" modal="true" [style]="{width: '800px'}" position="top" [closable]="false" [closeOnEscape]="false">
  <ng-template #header>
    <h3>Confirm Specimen, Name and DOB </h3> Sample {{order.Accession}}
  </ng-template>
  <div class="p-fluid grid">
    <div class="h4 col-12 p-formgroup-inline">
      <div class="h4 col-12 p-formgroup-inline">
        <div class="col-6">
          <div class="grid">
            <div class="col-12">
              Specimen: {{getSpecimenTypeNameByCode(order?.SpecimenTypeCode)}}
            </div>
            <div class="h6 col-12" *ngIf="order.PatientSampleObserved != null && order.PatientSampleObserved != order.SpecimenTypeCode">
              Observed: {{getSpecimenTypeNameByCode(order.PatientSampleObserved)}}
            </div>
          </div>
        </div>
        <div class="col-6 p-formgroup-inline">
          <div class="p-field-radiobutton">
            <p-radioButton name="specimenMatch" styleClass="radio-style"
                           [ngClass]="{'selectedgreen':order.SpecimenTypeMatch}" [value]="true" [(ngModel)]="order.SpecimenTypeMatch" label="Matches" (onClick)="changeSpecimenType($event)"></p-radioButton>
          </div>
          <div class="p-field-radiobutton">
            <p-radioButton name="specimenMatch" styleClass="radio-style"
                           [ngClass]="{'selectedexception':!order.SpecimenTypeMatch}" [value]="false" [(ngModel)]="order.SpecimenTypeMatch" label="Does not match" (onClick)="changeSpecimenType($event)"></p-radioButton>
          </div>
        </div>
      </div>
    </div>

    <div class="h4 col-12 p-formgroup-inline">
      <div class="h4 col-12 p-formgroup-inline">
        <div class="col-6 p-formgroup-inline">Name: {{order.FirstName}} {{order.LastName}}</div>
        <div class="col-6 p-formgroup-inline">
          <div class="p-field-radiobutton">
            <p-radioButton name="nameMatch" styleClass="radio-style"
                           [ngClass]="{'selectedgreen':order.NameMatch}" [value]="true" [(ngModel)]="order.NameMatch" label="Matches">
            </p-radioButton>
          </div>
          <div class="p-field-radiobutton">
            <p-radioButton name="nameMatch" styleClass="radio-style"
                           [ngClass]="{'selectedexception':order.NameMatch!= null && !order.NameMatch}" [value]="false" [(ngModel)]="order.NameMatch" label="Does not match">
            </p-radioButton>
          </div>
        </div>
      </div>

    </div>
    <div class="h4 col-12 p-formgroup-inline">
      <div class="h4 col-12 p-formgroup-inline">
        <div class="col-6 p-formgroup-inline">Birth Date: {{order.BirthDate | date:'MM/dd/yyyy' }}</div>
        <div class="col-6 p-formgroup-inline">
          <div class="p-field-radiobutton">
            <p-radioButton name="birthDateMatch" styleClass="radio-style"
                           [ngClass]="{'selectedgreen':order.BirthDateMatch}" [value]="true" [(ngModel)]="order.BirthDateMatch" label="Matches">
            </p-radioButton>
          </div>
          <div class="p-field-radiobutton">
            <p-radioButton name="birthDateMatch" styleClass="radio-style"
                           [ngClass]="{'selectedexception':order.BirthDateMatch!= null && !order.BirthDateMatch}" [value]="false" [(ngModel)]="order.BirthDateMatch" label="Does not match">
            </p-radioButton>
          </div>
        </div>
      </div>
    </div>


  </div>
  <div class="grid p-jc-center">
    <p-button (onClick)="cancelNameConfirmDialog()" icon="pi pi-trash" label="Cancel" class="p-m-2"></p-button>
    <p-button (onClick)="closeNameConfirmDialog()" icon="pi pi-check" label="Next" class="p-m-2" [disabled]="isNextDisabled()"></p-button>
  </div>
</p-dialog>

<p-dialog [(visible)]="showSpecimenSelectDialog" modal="true" [style]="{width: '800px'}" position="top" [closable]="false" [closeOnEscape]="false">
  <ng-template #header>
    <h3>Select Specimen </h3>
  </ng-template>
  <div class="p-fluid grid">
    <div class="h4 col-12 p-formgroup-inline">
      <div class="h4 col-12 p-formgroup-inline">
        <div class="col-6 p-formgroup-inline">
          <div col-md-12>
            <div *ngFor="let specimenType of specimensAvailableList();let i = index;" class="p-field-radiobutton">
              <div class="p-field-radiobutton" *ngIf="specimenType.Code != order.SpecimenTypeCode">
                <p-radioButton inpudIt="specimenType.Code" name="category" [value]="specimenType.Code" [(ngModel)]="order.PatientSampleObserved" [disabled]="specimenType.Code === 'R'" (onClick)="closeSpecimenConfirmDialog(false)"> </p-radioButton>
                <label for="{{specimenType.Code}}">{{specimenType.Name}}</label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="grid p-jc-center">
    <p-button (onClick)="closeSpecimenConfirmDialog(true)" icon="pi pi-trash" label="Cancel" class="p-m-2"></p-button>
  </div>
</p-dialog>

<p-dialog [(visible)]="showDuplicateDialog" modal="true" [style]="{width: '800px'}" position="top" [closable]="false" [closeOnEscape]="false">
  <ng-template #header>
    <h3 *ngIf="!order?.IsPatientMismatch">Duplicate</h3>
    <h3 *ngIf="order?.IsPatientMismatch">Label Mismatch</h3>
    Sample {{order?.SpecimenSerialNumber}}
  </ng-template>
  <div [hidden]="printLabelOption">
    <div class="p-fluid">
      A new number must be assigned to this sample.<br /><br />
      <div [hidden]="newSerial != null">
        Scan the new label (or enter it and press the search button) to verify the label is ok to use.<br />
      </div>
      <div [hidden]="newSerial == null || newSerialVerified == null || (newSerial && newSerialVerified)">
        Try a different label, the one you entered has already been used.<br />
      </div>
      <div class="p-inputgroup">
        <span class="p-input-icon-right">
          <input #rebarCode id="rebarCode" type="text" focus="true" pInputText [(ngModel)]="newSerial" style="width: 240px;margin-right:10px" />
          <i class="pi pi-check" [hidden]="newSerialVerified == null || newSerialVerified == false"></i>
          <i class="pi pi-times" [hidden]="newSerialVerified == null || newSerialVerified == true"></i>
        </span>
        <button (click)="verifyNewAccession()" style="margin-left:10px; width: 35px; padding:4px"><i class="fa fa-search"></i></button>
      </div>
      <div [hidden]="!newSerialVerified">
        Apply the new label to the sample, making sure to cover the existing bar code. Press the Label Is Applied button when complete.<br />
      </div>
    </div>

    <div class="grid p-jc-center margin-top-20">
      <p-button (onClick)="cancelDuplicateDialog()" icon="pi pi-trash" label="Cancel" class="p-m-2"></p-button>
      <p-button (onClick)="closeDuplicateDialog()" icon="pi pi-check" label="Label Is Applied" class="p-m-2" [disabled]="!newSerialVerified"></p-button>
    </div>
  </div>
  <div [hidden]="!printLabelOption">
    <div class="p-fluid grid">
      This serial number has already been processed. A new number must be assigned to this sample.<br /><br />
      Press the Print button to print a new label for it.<br />
      Apply the label on the sample so that it covers the existing bar code, and then press the Label Is Applied button<br />
    </div>
    <div class="print-container">
      <div id="label" style="min-height: 150px;">
        <div>
          {{order?.FirstName}} {{order?.LastName}} {{order?.BirthDate | date:'MM/dd/yyyy'}}
        </div>
        <div>
          <ngx-barcode6 [bc-value]="order?.Accession" [bc-display-value]="true" [bc-width]="2" [bc-height]="30" [bc-font-size]="12"></ngx-barcode6>
        </div>
      </div>
    </div>
    <div class="grid p-jc-center">
      <button class="navbutton" printSectionId="label" ngxPrint><i class="fa fa-print"></i> Print Label</button>
      <button class="navbutton" (click)="closeDuplicateDialog()"><i class="fa fa-check"></i> Label Is Applied</button>
    </div>
  </div>
</p-dialog>
